import type { DynamicClient } from '@dynamic-labs-sdk/client';
import { getNetworksData } from '@dynamic-labs-sdk/client';

type getNetworkIdFromNetworkNameParams = {
  networkName: string;
};

export const getNetworkIdFromNetworkName = (
  { networkName }: getNetworkIdFromNetworkNameParams,
  client: DynamicClient
) => {
  const networksData = getNetworksData(client);
  const btcNetworkData = networksData.filter((data) => data.chain === 'BTC');

  // try to find the correct networkId based on the network name (cluster)
  // if not found, default to mainnet ('1');
  const networkId =
    btcNetworkData.find((data) => data.cluster === networkName)?.networkId ??
    '1';

  return { networkId };
};
